import { useState } from "react";
import { toast } from "sonner";
import { Sparkles, Loader2 } from "lucide-react";
import { API } from "@/lib/api";

export default function AiDescribeButton({ assetType, details, onText }) {
  const [busy, setBusy] = useState(false);

  const run = async () => {
    setBusy(true);
    let text = "";
    try {
      const res = await fetch(`${API}/admin/ai/describe`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ asset_type: assetType, details }),
      });
      if (!res.ok) throw new Error("Could not generate a description");
      const reader = res.body.getReader();
      const decoder = new TextDecoder();
      let buffer = "";
      for (;;) {
        const { done, value } = await reader.read();
        if (done) break;
        buffer += decoder.decode(value, { stream: true });
        const parts = buffer.split("\n\n");
        buffer = parts.pop();
        for (const part of parts) {
          const line = part.replace(/^data: /, "");
          if (!line || line === "[DONE]") continue;
          const evt = JSON.parse(line);
          if (evt.error) throw new Error(evt.error);
          text += evt.text;
          onText(text);
        }
      }
    } catch (err) {
      toast.error(err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <button type="button" onClick={run} disabled={busy}
      className="inline-flex items-center gap-1.5 rounded-full border border-emerald-500/40 bg-emerald-500/10 px-3 py-1 text-xs text-emerald-400 transition-colors duration-200 hover:bg-emerald-500/20 disabled:opacity-60"
      data-testid="admin-generate-ai-desc-btn">
      {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Sparkles className="h-3.5 w-3.5" />}
      {busy ? "Writing..." : "Write with AI"}
    </button>
  );
}
